import {Injectable} from '@angular/core'

@Injectable({
  providedIn: 'root',
})
export class DomHelpersService {
  constructor() {}

  checkRowVisible(ingestSequence: string): boolean {
    let row = document.getElementById('row-' + ingestSequence)
    // early return when row is not in the dom
    if (!row) {
      return false
    }
    let containerHolder = document.getElementById('virtualScrollContainer')
    let cTop = containerHolder.getBoundingClientRect().top
    let cBottom = containerHolder.getBoundingClientRect().bottom
    let rTop = row.getBoundingClientRect().top
    let rBottom = row.getBoundingClientRect().bottom
    if (cTop <= rTop && rBottom <= cBottom) {
      return true
    }
    return false
  }
}
